module.exports = __webpack_public_path__ + "static/media/copiedBlue.41bb11fe.svg";